/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../plTheme';
import { _t_ } from '../../../utils/translation/translation';
interface OutcomeSummaryProps {
  reportRepOutcome: any;
  timePeriod: string;
}

const OutcomeSummary: React.FC<OutcomeSummaryProps> = ({
  reportRepOutcome,
  timePeriod,
}: OutcomeSummaryProps) => {
  const useStyles = makeStyles({
    outcomesHead: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 22,
      fontWeight: 500,
      fontFamily: 'Rubik',
      width: '100%',
    },
    closeIcon: {
      marginTop: '-20px',
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
    },
    heading: {
      fontFamily: 'Rubik',
      fontSize: 16,
      fontWeight: 500,
    },
    heading1: {
      fontFamily: 'Rubik',
      fontSize: 16,
      fontWeight: 500,
      color: '#fff',
    },
    elements: {
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: 14,
    },
    barTitle: {
      width: '100%',
      paddingTop: '2%',
    },
    title: {
      marginLeft: 8,
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 24,
    },
    container: {
      padding: '0 0 8px 12px',
      backgroundColor: 'white',
      height: 560,
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        width: 5,
        borderRadius: 4,
        marginRight: '8px',
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '8px',
        marginTop: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        maxHeight: 10,
        backgroundColor: COLORS.GREY_40,
        borderRadius: '10px',
      },
    },
    buttonFont: {
      fontFamily: 'Rubik',
      fontWeight: 500,
      fontSize: 14,
      textTransform: 'none',
      height: 40,
      width: 154,
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '68%',
      justifyContent: 'space-between',
    },
    row1: {
      height: 74,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    header: {
      backgroundColor: '#0B69FF',
      borderRadius: '6px 6px 0px 0px',
      '@media print': {
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
      },
    },
    tableBody: {
      borderRadius: ' 0px 0px 6px 6px',
      border: '1.4px solid #E0E0E0',
      '@media print': {
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
      },
    },
    row2: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '68%',
      justifyContent: 'space-between',
    },
    input: {
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 500,
      background: 'rgba(246, 246, 246, 1)',
      width: 88,
      height: 38,
      alignContent: 'center',
      border: '1px solid #0b69ffad',
      borderRadius: '6px',
    },
  });

  const classes = useStyles();

  const rowHeadList: any = {
    'Bookings ($ 000)': 'total_bookings_sum',
    'Deals Closed (#)': 'total_booked_deals_count',
    'Pipeline Generated ($ 000)': 'total_pipeline_generated',
    'Pipeline Deals (#)': 'total_pipeline_deals_count',
    'Avg. Deal Size ($ 000)': 'avg_deal_size',
    'Win Rate (%)': 'win_rate',
  };

  function nFormatter(num: any, digits: any) {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
      // { value: 1e6, symbol: 'M' },
      // { value: 1e9, symbol: 'G' },
      // { value: 1e12, symbol: 'T' },
      // { value: 1e15, symbol: 'P' },
      // { value: 1e18, symbol: 'E' },
    ];
    const rx = /\$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
      : '0';
  }
  const sortedSalesData = reportRepOutcome?.sort((a: any, b: any) => {
    const aValue = a.total_bookings_sum ? parseFloat(a.total_bookings_sum) : 0;
    const bValue = b.total_bookings_sum ? parseFloat(b.total_bookings_sum) : 0;

    // Handle null values - put them at the end
    if (a.total_bookings_sum === null && b.total_bookings_sum === null)
      return 0;
    if (a.total_bookings_sum === null) return 1;
    if (b.total_bookings_sum === null) return -1;

    return  aValue - bValue; // Descending order
  });
  const formatData = (name: string, index: any) => {
    let formattedValue = 'NA';
    if (
      sortedSalesData?.[index] &&
      sortedSalesData?.[index]?.data !== 'no data'
    ) {
      let value = +sortedSalesData[index][rowHeadList[name]];

      if (name.includes('$')) {
        // Format as currency
        if (value >= 1000000) {
          // For values greater than or equal to 1 million, divide by 1000 and format
          formattedValue = (value / 1000).toFixed(1); // Convert to thousands with 1 decimal
          formattedValue = Number(formattedValue).toLocaleString(); // Convert back to number and add commas
        } else if (value < 1000) {
          formattedValue = `${(value / 1000).toFixed(1)}`; // Show as 0.x if in hundreds
        } else {
          formattedValue = nFormatter(value, 1).replace('K', '');
          formattedValue = parseFloat(formattedValue).toLocaleString(); // Adds commas
        }
        formattedValue = formattedValue?.includes('.')
          ? formattedValue
          : `${formattedValue}.0`;
        // formattedValue = `${parseFloat(formattedValue).toFixed(1)}`; // Ensure 1 decimal place for all $
      } else if (name.includes('%')) {
        // Format as percentage with 1 decimal place always
        formattedValue = `${value.toFixed()}`;
      } else formattedValue = `${value}`;
    }
    return formattedValue;
  };

  return (
    <>
      <Grid
        container
        style={{
          width: '100%',
          margin: '24px 0',
        }}
      >
        <Typography className={classes.outcomesHead}>
          {`Summary : Outcomes (${timePeriod})`}
        </Typography>
      </Grid>
      <Grid className={classes.container}>
        <Grid className={`${classes.row1} ${classes.header}`}>
          <Grid
            style={{
              width: '29%',
              paddingLeft: 16,
            }}
          >
            <Typography className={`${classes.heading1}`}>
              Sales Outcome
            </Typography>
          </Grid>
          {sortedSalesData?.map((person: any, index: any) => (
            <Grid
              key={`head-${index}`}
              style={{
                textAlign: 'center',
                width: '23.6%',
              }}
            >
              <Typography className={`${classes.heading1}`}>
                {person.user_name}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <Grid className={classes.tableBody}>
          {Object.keys(rowHeadList).map((rowHead: string) => {
            return (
              <Grid className={classes.row1} key={rowHead}>
                <Grid
                  style={{
                    width: '29%',
                    paddingLeft: 16,
                  }}
                >
                  <Grid className={`${classes.heading}`} style={{fontSize: '14px'}}>
                    {rowHead.replace('_', '')}
                  </Grid>
                </Grid>
                <Grid
                  className={`${classes.heading}`}
                  style={{
                    textAlign: 'center',
                    width: '23.6%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Typography className={classes.input}>
                    {formatData(rowHead, 0)}
                  </Typography>
                </Grid>
                <Grid
                  className={`${classes.heading}`}
                  style={{
                    textAlign: 'center',
                    width: '23.6%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Typography className={classes.input}>
                    {formatData(rowHead, 1)}
                  </Typography>
                </Grid>
                <Grid
                  className={`${classes.heading}`}
                  style={{
                    textAlign: 'center',
                    width: '23.6%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Typography className={classes.input}>
                    {formatData(rowHead, 2)}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default OutcomeSummary;
